import {
  faCheckCircle,
  faExclamationCircle
} from '@fortawesome/free-solid-svg-icons';
import { currencyCodeToSign } from 'helpers/utils';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import DashboardKpiCard from './DashboardKpiCard';

const getSubscriptionFooter = subscription => {
  const cancelAt = _.get(subscription, 'CancelAt');
  const nextCharge = _.get(subscription, 'NextCharge');
  const endTime = _.get(subscription, 'EndTime');
  const daysRemaining = _.get(subscription, 'DaysRemaining');

  if (cancelAt) {
    return `Cancels ${moment.utc(cancelAt).local().format('MMM D, YYYY')}`;
  }

  if (nextCharge) {
    return `Next charge ${moment
      .utc(nextCharge)
      .local()
      .format('MMM D, YYYY')}`;
  }

  if (endTime) {
    return `Ends ${moment.utc(endTime).local().format('MMM D, YYYY')}`;
  }

  if (Number.isFinite(Number(daysRemaining))) {
    return `${Math.round(Number(daysRemaining))} day${
      Math.round(Number(daysRemaining)) === 1 ? '' : 's'
    } remaining`;
  }

  return '';
};

const DashboardSubscriptionKpiCard = () => {
  const { subscriptionStatus } = useSelector(state => state.subscription || {});
  const subscription = _.get(subscriptionStatus, 'Current', null);

  if (!subscription) {
    return (
      <DashboardKpiCard
        title="Subscription"
        value="Inactive"
        detail="No active subscription"
        icon={faExclamationCircle}
        accent="danger"
        footer="Review subscriptions"
      />
    );
  }

  const amount = `${currencyCodeToSign(subscription.Currency)}${
    subscription.Amount
  } / ${subscription.Recur}`;

  return (
    <DashboardKpiCard
      title="Subscription"
      value={subscription.Active ? 'Active' : 'Inactive'}
      detail={`${subscription.Type} ${amount}`}
      icon={subscription.Active ? faCheckCircle : faExclamationCircle}
      accent={subscription.Active ? 'success' : 'warning'}
      footer={getSubscriptionFooter(subscription)}
    />
  );
};

export default DashboardSubscriptionKpiCard;
